import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=74bc9898&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=ts&"
export * from "./step1.vue?vue&type=script&lang=ts&"
import style0 from "./step1.vue?vue&type=style&index=0&id=74bc9898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc9898",
  null
  
)

export default component.exports